/**
 * @name sendIoPageEvent
  * @description Send pageview event to IO tracking system.
*/

export const sendIoPageEvent = (): void => {
  if (window.ioSettings !== undefined) {
    const ioPageViewConfig = {
        event: 'pageviews',
        config_page_url: window.ioSettings.page_url,
        type_article: 'Listed'
    };

    try {
        window.io(ioPageViewConfig);
    } catch (e) {
        console.error(e);
    }
  }
}